export enum DtoParserType {
  Csas = 'csas',
  Default = 'default',
}
